import { all, fork, put, take, delay, call } from 'redux-saga/effects';
import { ExternalUserValidationError, InternalUserValidationError } from '@ts/utils/errors';
import actions from '../actions';

const isProd = process.env.NODE_ENV === 'production';

export function* onError() {
    while (true) {
        const action = yield take(actions.app.ActionTypes.ERROR);

        const isExcludedFromLogError =
            action.error instanceof InternalUserValidationError ||
            action.error instanceof ExternalUserValidationError;

        if (!isProd) {
            console.warn(
                '[DEV-only]',
                'Something went wrong and we caught the error!',
                action.error
            );
        } else if (!isExcludedFromLogError) {
            console.log(action.error);
        }
    }
}

export function* onPushLocation() {
    while (true) {
        const { location } = yield take(actions.app.ActionTypes.PUSH_LOCATION);

        if (!isProd) {
            console.info('[DEV-only]', 'PushLocation', location);
        }

        yield call(window.browserHistory.push, location);
    }
}

export function* initTick() {
    while (true) {
        if (isProd) {
            yield delay(1000);
        } else {
            yield delay(1000);
        }
        yield put(actions.app.tick());
    }
}

export default function* appSaga() {
    yield all([fork(onError), fork(onPushLocation), fork(initTick)]);
}
